<div class="position-relative mt-5" [ngStyle]="{ height: height }">
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
